export default __webpack_public_path__ + "static/media/International Workers Day.1ae977d3.jpg";